import { SearchOptions, SearchResponse } from '@algolia/client-search';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { EuresAlgoliaFilterItem } from '@models/eures/search-filters';
import { AlgoliaClientService } from '@wizbii/algolia';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class EuresSearchFiltersWebservice {
  constructor(private readonly algoliaClientService: AlgoliaClientService) {}

  getContracts(query: string, searchParams?: SearchOptions): Observable<Record<string, string>> {
    const index = this.algoliaClientService.client.initIndex(environment.algolia.index.euresContracts);

    return from(index.search<EuresAlgoliaFilterItem>(query, searchParams)).pipe(
      map((results) => this.listToObject(results.hits))
    );
  }

  getSectors(query: string, searchParams?: SearchOptions): Observable<Record<string, string>> {
    const index = this.algoliaClientService.client.initIndex(environment.algolia.index.euresSectors);

    return from(index.search<EuresAlgoliaFilterItem>(query, searchParams)).pipe(
      map((results) => this.listToObject(results.hits))
    );
  }

  getOccupations(query: string, searchParams?: SearchOptions): Observable<SearchResponse<EuresAlgoliaFilterItem>> {
    const index = this.algoliaClientService.client.initIndex(environment.algolia.index.euresOccupations);

    return from(index.search<EuresAlgoliaFilterItem>(query, searchParams));
  }

  getCountries(query: string, searchParams?: SearchOptions): Observable<SearchResponse<EuresAlgoliaFilterItem>> {
    const index = this.algoliaClientService.client.initIndex(environment.algolia.index.euresCountries);

    return from(index.search<EuresAlgoliaFilterItem>(query, searchParams));
  }

  private listToObject(list: EuresAlgoliaFilterItem[]): Record<string, string> {
    const obj: any = {};
    list.forEach((i) => (obj[i.objectID] = i.name));
    return obj;
  }
}
